/**
 * All project/article detail page modules are to use 3:2 (landscape) or 2:3
 * (portrait) aspect ratios.  Backend CDN crops (ColumnDimensionCreateService)
 * and frontend CSS containers (DetailSingleImageShell.style.ts) must stay in
 * sync — arbitrary ratios cause double-crop problems and client confusion.
 */

export const FULL_COLUMN_WIDTH = 1920;
export const FULL_COLUMN_WIDTH_MOBILE = 414;
export const COLUMN_WIDTH_100 = 1820;
export const DUO_COLUMN_WIDTH = 1440;
// the min width for the medium image of the DuoImageModule
export const DUO_COLUMN_WIDTH_MD = 614;
export const TRIO_COLUMN_WIDTH_MD = 434;
export const GALLERY_COLUMN_WIDTH = 434;
export const GALLERY_COLUMN_WIDTH_MOBILE = 186;
export const GALLERY_ITEMS_PER_ROW = 4;
export const PARAGRAPH_PHOTO_WIDTH = 1050;
export const ROW_GAP_MOBILE = 30;
export const SINGLE_COLUMN_WIDTH = 436;
const BANNER_WIDTH_TABLET = 742;
export const BANNER_WIDTH_FULL_MOBILE = 414;
const BANNER_HEIGHT_DESKTOP = 1084;
const BANNER_HEIGHT_TABLET = 494;
const BANNER_HEIGHT_FULL_MOBILE = 378;

export const FULL_COLUMN_WIDTH_FULL_SCREEN = 1920;
export const BANNER_HEIGHT_DESKTOP_FULL_SCREEN = 1084;

export const BANNER_DIMENSIONS = {
    id: 0,
    width: FULL_COLUMN_WIDTH,
    height: BANNER_HEIGHT_DESKTOP,
    tabletWidth: BANNER_WIDTH_TABLET,
    tabletHeight: BANNER_HEIGHT_TABLET,
    mobileWidth: BANNER_WIDTH_FULL_MOBILE,
    mobileHeight: BANNER_HEIGHT_FULL_MOBILE,
    builderWidth: FULL_COLUMN_WIDTH,
    builderHeight: BANNER_HEIGHT_DESKTOP,
    isPortrait: false,
};
